/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */

import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

export default {
    props: {
        assets: {
            type: Array,
        },
    },

    async mounted() {
        if (!this.assets) return;
        await this.initSwiper();
    },

    methods: {
        async initSwiper() {
            const { Swiper } = await getSwiper();
            const { Pagination } = await getSwiperModules();

            const element = document.querySelector(
                '.slider-section-features__images-container--desktop',
            );

            new Swiper(element, {
                slidesPerView: 1,
                spaceBetween: 0,
                modules: [Pagination],
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
            });
        },
    },
};
